import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgComputer = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 88 71.97",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fff;}\n      .cls-2{fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M3.04 2.68h83.12v49.03H3.04z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M1.81,0C.78.1,0,.97,0,2v54.06c0,1.1.9,2,2,2h84c1.1,0,2-.9,2-2V2c0-1.1-.9-2-2-2H1.81ZM4,4h80v43.25H4V4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M35.09,59.82c-.12.02-.23.05-.34.09-.18.05-.34.12-.5.22-.02,0-.04.02-.06.03l-.03.03s-.08.06-.12.09l-.03.03s-.08.06-.12.09v.03s-.09.08-.12.12v.03s-.09.08-.12.12v.03s-.06.1-.09.16v.03s-.06.1-.09.16v.03c-.04.11-.07.23-.09.34v.03c-.04.21-.05.42-.03.62-.04.57-.17.81-.44,1.09-.31.33-.9.71-1.69,1.12-.78.42-1.76.9-2.66,1.78-.9.89-1.59,2.31-1.56,3.91.02,1.09.91,1.97,2,1.97h30.09c1.09,0,1.98-.88,2-1.97.03-1.6-.66-3.02-1.56-3.91-.9-.88-1.87-1.36-2.66-1.78s-1.38-.79-1.69-1.12c-.27-.29-.44-.51-.47-1.12.04-.28.02-.57-.06-.84v-.03s-.04-.11-.06-.16v-.03s-.06-.11-.09-.16v-.03s-.06-.08-.09-.12v-.03s-.08-.09-.12-.12v-.03s-.08-.09-.12-.12l-.03-.03s-.08-.09-.12-.12h-.03s-.06-.04-.09-.06l-.06-.06s-.08-.06-.12-.09h-.03s-.1-.04-.16-.06c-.25-.1-.51-.16-.78-.16-.14,0-.27,0-.41.03h-16.59c-.13-.02-.27-.03-.41-.03h-.25Z"
		})
	]
});
export default SvgComputer;
